<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Manage action statuses and their visibility rules. Configure which statuses are visible based on different conditions.
    </p>
    <div class="adf-hero-stats" *ngIf="isConfigurationReady && ((statusList.sequenced.length || 0) + (statusList.unsequenced.length || 0)) > 0">
      <div class="adf-stat">
        <span class="adf-stat-value">{{ (statusList.sequenced.length || 0) + (statusList.unsequenced.length || 0) }}</span>
        <span class="adf-stat-label">Statuses</span>
      </div>
      <div class="adf-stat">
        <span class="adf-stat-value">{{ pagination.statusRulesCount || 0 }}</span>
        <span class="adf-stat-label">Rules</span>
      </div>
    </div>
  </div>

  <div class="adf-loader" *ngIf="!isConfigurationReady">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="adf-content" *ngIf="isConfigurationReady">
    <div class="adf-control-bar">
      <div class="adf-control-bar-main">
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openModal()">
          New {{ viewMode === 'basic' ? 'Status' : 'Rule' }}
        </button>

        <div class="adf-control-divider" aria-hidden="true"></div>

        <div class="adf-view-toggle" role="tablist" aria-label="View mode">
          <button type="button" role="tab" class="adf-toggle-btn"
            [class.active]="viewMode === 'basic'"
            [attr.aria-selected]="viewMode === 'basic'"
            (click)="setViewMode('basic')">Statuses</button>
          <button type="button" role="tab" class="adf-toggle-btn"
            [class.active]="viewMode === 'advanced'"
            [attr.aria-selected]="viewMode === 'advanced'"
            (click)="setViewMode('advanced')">Rules</button>
        </div>
      </div>

      <div class="adf-control-bar-tools">
        <div class="adf-search" *ngIf="viewMode === 'basic'">
          <span class="adf-search-icon" aria-hidden="true">
            <svg class="icon-set">
              <use [attr.xlink:href]="'./assets/images/icons.svg#search'"></use>
            </svg>
          </span>
          <input type="text" class="adf-search-input" placeholder="Search statuses…"
            [(ngModel)]="lwActionStatusBasicSearch"
            (input)="onSearchChange()" (keyup)="onSearchChange()"
            [disabled]="!statusListBackup || statusListBackup.length === 0">
        </div>
        <div class="adf-search" *ngIf="viewMode === 'advanced'">
          <span class="adf-search-icon" aria-hidden="true">
            <svg class="icon-set">
              <use [attr.xlink:href]="'./assets/images/icons.svg#search'"></use>
            </svg>
          </span>
          <input type="text" class="adf-search-input" placeholder="Search rules…"
            [(ngModel)]="lwActionStatusAdvancedSearch"
            (input)="onSearchChange()" (keyup)="onSearchChange()"
            [disabled]="!statusRulesBackup || statusRulesBackup.length === 0">
        </div>

        <div class="adf-paging" *ngIf="viewMode === 'advanced' && statusRules?.length">
          <button type="button" [disabled]="pagination.disablePrev" (click)="getRules(false)" title="Previous">
            <img src="assets/images/chevron-left.svg" alt="" />
          </button>
          <span [class.disabled]="pagination.statusRulesCount <= 0">
            {{ pagination.statusRulesPageFrom }}–{{ pagination.statusRulesPageTo }} / {{ pagination.statusRulesCount }}
          </span>
          <button type="button" [disabled]="pagination.disableNext" (click)="getRules(true)" title="Next">
            <img src="assets/images/chevron-right.svg" alt="" />
          </button>
        </div>
      </div>
    </div>

    <div class="adf-info-banner" *ngIf="viewMode === 'advanced'">
      <div class="adf-info-banner-body">
        <span class="adf-info-dot" aria-hidden="true"></span>
        <span>
          By default, all Statuses are <strong>Visible</strong>. Rules here hide them.
        </span>
      </div>
      <button type="button" class="adf-icon-btn" (click)="closeBanner()" title="Dismiss">
        <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#close'"></use>
        </svg>
      </button>
    </div>

    <!-- Basic View -->
    <div class="adf-fields" *ngIf="viewMode === 'basic'">
      <div
        *ngIf="(!statusList.sequenced || statusList.sequenced.length === 0) && (!statusList.unsequenced || statusList.unsequenced.length === 0)"
        class="adf-empty">
        <div class="adf-empty-visual" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>
        <div class="adf-empty-title">No statuses yet</div>
        <div class="adf-empty-text">Create a status to start organizing action progress.</div>
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openModal()">
          New Status
        </button>
      </div>

      <div class="adf-status-panel" *ngIf="statusList.sequenced.length || statusList.unsequenced.length">
        <div class="adf-children"
          *ngIf="statusList.sequenced.length"
          cdkDropList
          id="status-sequenced-list"
          [cdkDropListData]="statusList.sequenced"
          [cdkDropListConnectedTo]="[]"
          [cdkDropListDisabled]="isDragDisabled()"
          (cdkDropListDropped)="onStatusDrop($event)">
          <div class="adf-child"
            *ngFor="let status of statusList.sequenced; let i = index; trackBy: trackByStatusId"
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragData]="status"
            [cdkDragDisabled]="isDragDisabled()">
            <div class="field-drag-placeholder field-drag-placeholder--field" *cdkDragPlaceholder></div>
            <div class="adf-child-row">
              <div class="adf-child-left">
                <button type="button" class="adf-drag-handle adf-drag-handle--sm" cdkDragHandle
                  title="Drag to reorder status" [class.disabled]="isDragDisabled()"
                  aria-label="Reorder status">
                  <svg class="icon-set">
                    <use [attr.xlink:href]="'./assets/images/icons.svg#reorder'"></use>
                  </svg>
                </button>
                <span class="adf-index">{{ status.sequence || (i + 1) }}</span>
                <span class="adf-status-color" [style.background-color]="status.color"></span>
                <span class="adf-child-name">{{ status.name }}</span>
              </div>
              <div class="adf-child-actions">
                <button type="button" [disabled]="readonly" class="adf-icon-btn" (click)="editStatus(status)" title="Edit status">
                  <svg class="icon-set">
                    <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
                  </svg>
                </button>
                <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteStatus(status)" title="Delete status">
                  <svg class="icon-set">
                    <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="adf-children adf-children--spaced" *ngIf="statusList.unsequenced.length">
          <div class="adf-section-label" *ngIf="statusList.sequenced.length">Unsequenced</div>
          <div class="adf-child" *ngFor="let status of statusList.unsequenced">
            <div class="adf-child-row">
              <div class="adf-child-left">
                <span class="adf-index adf-index--muted">—</span>
                <span class="adf-status-color" [style.background-color]="status.color"></span>
                <span class="adf-child-name">{{ status.name }}</span>
              </div>
              <div class="adf-child-actions">
                <button type="button" class="adf-icon-btn" (click)="editStatus(status)" title="Edit status">
                  <svg class="icon-set">
                    <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
                  </svg>
                </button>
                <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteStatus(status)" title="Delete status">
                  <svg class="icon-set">
                    <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Advanced View -->
    <div class="adf-rules" *ngIf="viewMode === 'advanced'">
      <div class="adf-rules-list" *ngIf="statusRules?.length">
        <div class="adf-rule-card" *ngFor="let rule of statusRules">
          <div class="adf-rule-main">
            <div class="adf-rule-title-row">
              <h4 class="adf-rule-name">{{ rule.name }}</h4>
              <span class="adf-status-pill" [class.is-on]="rule.is_enabled" [class.is-off]="!rule.is_enabled">
                {{ rule.is_enabled ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="adf-rule-meta">
              <span class="adf-rule-meta-text">Created : {{ rule.formatted_created_date || (rule.created_date | date:'dd-MMM-yy HH:mm') }}</span>
              <span class="adf-meta-dot" aria-hidden="true"></span>
              <span class="adf-rule-meta-text">Updated : {{ rule.formatted_last_updated || (rule.last_updated_on | date:'dd-MMM-yy HH:mm') }}</span>
            </div>
          </div>
          <div class="adf-rule-side">
            <label class="adf-switch" title="Toggle active">
              <input type="checkbox" [disabled]="readonly" [checked]="rule.is_enabled" (change)="toggleRule(rule)">
              <span class="adf-switch-slider"></span>
            </label>
            <button type="button" class="adf-icon-btn" (click)="editRule(rule)" title="Edit rule">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
              </svg>
            </button>
            <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteRule(rule)" title="Delete rule">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="adf-empty" *ngIf="!statusRules?.length">
        <div class="adf-empty-visual adf-empty-visual--rules" aria-hidden="true">
          <span></span><span></span>
        </div>
        <div class="adf-empty-title">No rules yet</div>
        <div class="adf-empty-text">Create a rule to hide statuses based on conditions.</div>
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openModal()">
          New Rule
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()"></div>
  <aside class="right-modal" *ngIf="isModalOpen" [class.open]="isModalOpen" aria-modal="true" role="dialog">
    <dynamic-action-form-renderer [readonly]="readonly" [schema]="modalSchema" [data]="defaultValues" (reset)="closeModal()" (close)="closeModal()"
      (submit)="submitForm($event)">
    </dynamic-action-form-renderer>
  </aside>
</div>
